import {
  Autocomplete,
  Button,
  Checkbox,
  FormControlLabel,
  FormControl,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { useGetProviders } from '../../../lib/react-query/providerQuery';

const PROVIDER_SIN_DEFINIR = {
  _id: 'SIN_DEFINIR',
  shortName: 'Sin definir',
};

const FormProviderAsociate = ({ formik, goBack, custom }) => {
  const { providers, loadingProviders } = useGetProviders();

  const createEmptyProvider = () => ({
    code: '',
    price: '',
    provider: '',
    active: true,
    allowDuplicateCode: false,
  });

  const providersList = formik.values.providers || [];
  const providerOptions = loadingProviders ? [] : [PROVIDER_SIN_DEFINIR, ...(providers?.data || [])];

  const handleAddProvider = () => {
    formik.setFieldValue('providers', [...providersList, createEmptyProvider()]);
  };

  const handleRemoveProvider = (providerIndex) => {
    const updatedProviders = [...providersList];
    updatedProviders.splice(providerIndex, 1);
    formik.setFieldValue('providers', updatedProviders);
  };

  const handleProviderFieldChange = (providerIndex, field, value) => {
    const updatedProviders = [...providersList];

    updatedProviders[providerIndex] = {
      ...updatedProviders[providerIndex],
      [field]: value,
    };

    formik.setFieldValue('providers', updatedProviders);
  };

  const handlePriceChange = (providerIndex, value) => {
    if (/^[0-9]*[.,]?[0-9]*$/.test(value)) {
      handleProviderFieldChange(providerIndex, 'price', value);
    }
  };

  return (
    <>
      <Typography
        variant="h4"
        component="h2"
        align="center"
        sx={{
          fontWeight: 'bold',
          marginBottom: '1.5rem',
          backgroundColor: '#3C4145',
          color: 'white',
        }}
      >
        {`Asociar proveedores al formato ${custom ? 'personalizable' : ''}`}
      </Typography>

      <form onSubmit={formik.handleSubmit}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '1.5rem',
            gap: '1rem',
          }}
        >
          <Typography variant="h6">Proveedores del formato</Typography>

          <Button variant="outlined" startIcon={<AddIcon />} onClick={handleAddProvider}>
            Añadir proveedor
          </Button>
        </div>

        {providersList.length === 0 && (
          <Typography variant="body2" style={{ marginBottom: '1rem' }}>
            Todavía no has añadido ningún proveedor para este formato.
          </Typography>
        )}

        {providersList.map((providerItem, providerIndex) => (
          <Paper
            key={providerIndex}
            variant="outlined"
            style={{
              padding: '1rem',
              marginBottom: '1rem',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '1rem',
              }}
            >
              <Typography variant="body1">Proveedor {providerIndex + 1}</Typography>

              <IconButton color="error" onClick={() => handleRemoveProvider(providerIndex)}>
                <DeleteIcon />
              </IconButton>
            </div>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Código Ariba"
                  value={providerItem.code}
                  onChange={(e) => handleProviderFieldChange(providerIndex, 'code', e.target.value)}
                />
              </Grid>

              {!custom && (
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    label="Precio"
                    value={providerItem.price}
                    onChange={(e) => handlePriceChange(providerIndex, e.target.value)}
                  />
                </Grid>
              )}

              <Grid item xs={12} sm={4}>
                <FormControl variant="outlined" fullWidth>
                  <Autocomplete
                    options={providerOptions}
                    getOptionLabel={(option) => option?.shortName || ''}
                    value={providerOptions.find((provider) => provider._id === providerItem.provider) || null}
                    onChange={(event, newValue) => {
                      handleProviderFieldChange(providerIndex, 'provider', newValue ? newValue._id : '');
                    }}
                    isOptionEqualToValue={(option, value) => option?._id === value?._id}
                    renderInput={(params) => <TextField {...params} label="Proveedor" variant="outlined" fullWidth />}
                    noOptionsText="Sin proveedor"
                    loading={loadingProviders}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!providerItem.allowDuplicateCode}
                      onChange={(e) => handleProviderFieldChange(providerIndex, 'allowDuplicateCode', e.target.checked)}
                    />
                  }
                  label="Permitir repetir código"
                />
              </Grid>
            </Grid>
          </Paper>
        ))}

        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '1rem' }}>
          <Button type="submit" variant="contained" style={{ backgroundColor: '#3C4145' }} endIcon={<SendIcon />}>
            Crear
          </Button>

          <Button variant="contained" color="error" endIcon={<CloseIcon />} onClick={goBack}>
            {custom ? 'Cancelar' : 'Atras'}
          </Button>
        </div>
      </form>
    </>
  );
};

export default FormProviderAsociate;
